module.exports = __webpack_public_path__ + "img/145.2.aea83cd2.png";